import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./CSS/Pumps.css";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_pumps_tags,
  set_tag_values,
  set_external_trend_info,
} from "../Action/Action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

let state_2 = [
  {
    "ESANJÖR POMPA GRUBU DURUM İZLEMESİ ": [
      { text: "P1 Çalışma Durumu", tagId: "105" },
      { text: "P1 Arıza Durumu", tagId: "106" },
      { text: "P2 Çalışma Durumu", tagId: "123" },
      { text: "P2 Arıza Durumu", tagId: "124" },
      { text: "P1 Tüketim(kWh)", tagId: "5006", class: "pumps-kwh" },
      { text: "P2 Tüketim(kWh)", tagId: "5021", class: "pumps-kwh" },
      { text: "P1 Akım", tagId: "64", class: "pumps-p1-p2" },
      { text: "", tagId: "65" },
      { text: "", tagId: "66" },
      { text: "P2 Akım", tagId: "67", class: "pumps-p1-p2" },
      { text: "", tagId: "68" },
      { text: "", tagId: "69" },
    ],
  },
  {
    "KULLANMA SUYU POMPA GRUBU DURUM İZLEMESİ ": [
      { text: "P1 Çalışma Durumu", tagId: "107" },
      { text: "P1 Arıza Durumu", tagId: "108" },
      { text: "P2 Çalışma Durumu", tagId: "109" },
      { text: "P2 Arıza Durumu", tagId: "110" },
      { text: "P1 Tüketim(kWh)", tagId: "5013", class: "pumps-kwh" },
      { text: "P2 Tüketim(kWh)", tagId: "5014", class: "pumps-kwh" },
      { text: "P1 Akım", tagId: "91", class: "pumps-p1-p2" },
      { text: "", tagId: "92" },
      { text: "", tagId: "93" },
      { text: "P2 Akım", tagId: "88", class: "pumps-p1-p2" },
      { text: "", tagId: "89" },
      { text: "", tagId: "90" },
    ],
  },
  {
    "BOYLER SİRKÜLASYON POMPA GRUBU DURUM İZLEMESİ ": [
      { text: "P1 Çalışma Durumu", tagId: "111" },
      { text: "P1 Arıza Durumu", tagId: "112" },
      { text: "P2 Çalışma Durumu", tagId: "113" },
      { text: "P2 Arıza Durumu", tagId: "114" },
      { text: "P1 Tüketim(kWh)", tagId: "5015", class: "pumps-kwh" },
      { text: "P2 Tüketim(kWh)", tagId: "5016", class: "pumps-kwh" },
      { text: "P1 Akım", tagId: "85", class: "pumps-p1-p2" },
      { text: "", tagId: "86" },
      { text: "", tagId: "87" },

      { text: "P2 Akım", tagId: "82", class: "pumps-p1-p2" },
      { text: "", tagId: "83" },
      { text: "", tagId: "84" },
    ],
  },
  {
    "ISI POMPASI POMPA GRUBU DURUM İZLEMESİ ": [
      { text: "P1 Çalışma Durumu", tagId: "115" },
      { text: "P1 Arıza Durumu", tagId: "116" },
      { text: "P2 Çalışma Durumu", tagId: "117" },
      { text: "P2 Arıza Durumu", tagId: "118" },
      { text: "P1 Tüketim(kWh)", tagId: "5017", class: "pumps-kwh" },
      { text: "P2 Tüketim(kWh)", tagId: "5018", class: "pumps-kwh" },
      { text: "P1 Akım", tagId: "79", class: "pumps-p1-p2" },
      { text: "", tagId: "80" },
      { text: "", tagId: "81" },

      { text: "P2 Akım", tagId: "76", class: "pumps-p1-p2" },
      { text: "", tagId: "77" },
      { text: "", tagId: "78" },
    ],
  },
  {
    "BOOSTER POMPA GRUBU DURUM İZLEMESİ ": [
      { text: "P1 Çalışma Durumu", tagId: "119" },
      { text: "P1 Arıza Durumu", tagId: "120" },
      { text: "P2 Çalışma Durumu", tagId: "121" },
      { text: "P2 Arıza Durumu", tagId: "122" },
      { text: "P1 Tüketim(kWh)", tagId: "5019", class: "pumps-kwh" },
      { text: "P2 Tüketim(kWh)", tagId: "5020", class: "pumps-kwh" },
      { text: "P1 Akım", tagId: "73", class: "pumps-p1-p2" },
      { text: "", tagId: "74" },
      { text: "", tagId: "75" },
      { text: "P2 Akım", tagId: "70", class: "pumps-p1-p2" },
      { text: "", tagId: "71" },
      { text: "", tagId: "72" },
    ],
  },
  {
    "ELEKTRİK YANGIN POMPA GRUBU DURUM İZLEMESİ ": [
      { text: "Çalışma Durumu", tagId: "125" },
      { text: "Arıza Durumu", tagId: "126" },
    ],
  },
  {
    "ATIK SU POMPA GRUBU DURUM İZLEMESİ ": [
      { text: "P1 Çalışma Durumu", tagId: "129" },
      { text: "P1 Arıza Durumu", tagId: "130" },
      { text: "P2 Çalışma Durumu", tagId: "131" },
      { text: "P2 Arıza Durumu", tagId: "132" },
    ],
  },
];

const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  state_2.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/pumps") {
        try {
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            {
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
              },
              method: "POST",
              body: JSON.stringify(obj2__),
            }
          );
          const response = await request.json();

          // response.forEach(a=>{
          //     liste.push(a)
          // })

          Store.dispatch(set_pumps_tags(response));
        } catch (err) {
          console.log(err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 4000);
};

setTimeout(() => {
  inital_func();
}, 1000);

const Pumps = (props) => {
  const [tag_values, Set_tag_values] = useState([]);
  const history = useHistory();
  const [state, SetState] = useState(state_2);

  const maxValueByType = {
    TÜKETİM: 15000,
    GÜÇ: 10000,
    "L1 GERİLİM": 240,
    "L2 GERİLİM": 240,
    "L3 GERİLİM": 240,
    "L1 AKIM": 250,
    "L2 AKIM": 250,
    "L3 AKIM": 250,
    "GÜÇ FAKTÖRÜ": 1,
    "REAKTIF GÜÇ": 1000,
    FREKANS: 100,
  };
  const minValueByType = {
    "L1 GERİLİM": 210,
    "L2 GERİLİM": 210,
    "L3 GERİLİM": 210,
  };

  useEffect(() => {
    console.log(props.tag_values);
    //

    Set_tag_values(props.tag_values);
  }, [props.tag_values]);

  useEffect(() => {
    const componentDidMount = () => {
      var obj__ = [];
      var obj2__ = [];

      state_2.forEach((item) => {
        Object.entries(item).forEach((a) => {
          obj__.push(a[1]);
        });
      });

      obj__.forEach((item2) => {
        item2.forEach((item3) => {
          obj2__.push({ tagId: item3.tagId });
        });
      });

      var newdata = [];

      obj2__.forEach((item2) => {
        props.tag_values.forEach((item) => {
          if (item.tagId === item2.tagId) {
            newdata.push({
              tagId: item.tagId,
              tagValue: item.tag_value,
            });
          }
        });
      });

      console.log(newdata);
      //

      Set_tag_values(newdata);
    };

    componentDidMount();
  }, []);

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const getBackgroundStyle = (type, valueString) => {
    const numericValue = parseFloat(valueString);
    const maxValue = maxValueByType[type] || 1;
    const minValue = minValueByType[type] || 0;
    const adjustedValue = Math.max(numericValue - minValue, 0);
    const adjustedMaxValue = maxValue - minValue;
    const ratio = Math.min(Math.max(adjustedValue / adjustedMaxValue, 0), 1);
    if (type.includes("Çalışma Durumu")) {
      return {
        background: `linear-gradient(to right, rgb(76, 187, 23) ${
          ratio * 100
        }%, white ${ratio * 100}%)`,
      };
    } else if (type.includes("P1 Tüketim(kWh)")) {
      return {};
    } else if (type.includes("P2 Tüketim(kWh)")) {
      return {};
    } else if (type.includes("Arıza Durumu") || type.includes("Alarm")) {
      return {
        background: `linear-gradient(to right, 	rgb(255, 36, 0) ${
          ratio * 100
        }%, white ${ratio * 100}%)`,
      };
    }
    return {
      background: `linear-gradient(to right, rgb(237, 188, 69) ${
        ratio * 100
      }%, white ${ratio * 100}%)`,
    };
  };

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };

  // setInterval(() => {

  //     console.log(control);

  //     if (props.tag_ids && control === true && window.location.pathname === "/energy") {
  //         const fetch_tag_values = async () => {
  //             try {
  //                 const request = await fetch(
  //                     "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
  //                     {
  //                         headers: {
  //                             "Content-Type": "application/json",
  //                             accept: "application/json",
  //                         },
  //                         method: "POST",
  //                         body: JSON.stringify(obj2__),
  //                     }
  //                 );
  //                 const response = await request.json();

  //                 console.log(response);

  //                 Set_tag_values(response);
  //             } catch (err) {
  //                 console.log(err);
  //             } finally {
  //                 Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false))
  //             }
  //         }

  //         fetch_tag_values()
  //     }

  // }, 10000)

  const loadingStyle = {
    background: "linear-gradient(to right, #f0f0f0 50%, white 50%)",
  };
  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <section className="section_pumps">
        <Link to="/pumps_system">
          <Button
            style={{
              position: "absolute",
              color: "black",
              top: "12%",
              left: "18%",
              zIndex: 9999999,
              borderRadius: "15px",
              backgroundColor: "#fff",
              border: "3px solid rgba(238, 200, 108, 0.99)",
              fontWeight: 600,
            }}
            className=" movebuttons"
            variant="contained"
          >
            Geri
          </Button>
        </Link>
        <div className="pumpstop">
          <div>POMPALAR</div>
        </div>

        <div className="bottom_pumps">
          {state.map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              title.push(a[0]);
              obj_.push(a[1]);
            });

            console.log(obj_);
            // var değer = tag_values
            //     .filter(
            //         (x) => String(x.tagId) === String(item.elementDetails.tagId)
            //     )
            //     .map((a) => a.tagValue);
            return (
              <div className="rows">
                <div className="left">
                  <div></div>
                  <div className="lefttitle">{title[0]}</div>
                </div>
                <div className="right">
                  <div className="right_top">
                    {obj_[0].map((x, index) => {
                      const className =
                        x.text === ""
                          ? "pumpsdisplayNone"
                          : `${x.class} righttop`;
                      console.log(x);
                      return (
                        <div className={x.class + " " + className}>
                          {x.text !== "" ? x.text : ""}
                        </div>
                      );
                    })}
                  </div>
                  <div className="right_bottom">
                    {obj_[0].map((x, index) => {
                      console.log(x);
                      let array__ = [
                        "64",
                        "65",
                        "66",
                        "67",
                        "68",
                        "69",
                        "70",
                        "71",
                        "72",
                        "73",
                        "74",
                        "75",
                        "76",
                        "77",
                        "78",
                        "79",
                        "80",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85",
                        "86",
                        "87",
                        "88",
                        "89",
                        "90",
                        "91",
                        "92",
                        "93",
                      ];

                      if (array__.indexOf(x.tagId) < 0) {
                        var değerler = props.pumps_tags
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        function sondanIlkBoslukIndexiniBul(metin) {
                          console.log(metin);
                          if (metin !== undefined) {
                            // Metni ters çevir
                            var tersMetin = metin.split("").reverse().join("");

                            // İlk boşluğun index'ini bul
                            var ilkBoslukIndex = tersMetin.indexOf(" ");

                            // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                            var orijinalIndex =
                              metin.length - 1 - ilkBoslukIndex;

                            return orijinalIndex;
                          }
                        }

                        function metniIndexeKadarAl(metin, index) {
                          if (metin !== undefined) {
                            // substring kullanarak
                            var metinSubstring = metin.substring(0, index);

                            // veya slice kullanarak

                            metinSubstring = String(metinSubstring);
                            metinSubstring = metinSubstring.replaceAll(
                              ",",
                              "."
                            );

                            metinSubstring = Number(metinSubstring).toFixed(2);

                            return metinSubstring;
                          }
                        }

                        function sondanIlkBosluktanSonrakiKisim(metin) {
                          if (metin !== undefined) {
                            // Metni ters çevir
                            var tersMetin = metin.split("").reverse().join("");

                            // İlk boşluğun index'ini bul
                            var ilkBoslukIndex = tersMetin.indexOf(" ");

                            // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                            var orijinalIndex =
                              metin.length - 1 - ilkBoslukIndex;

                            // İlk boşluğun index'inden sonraki kısmı al
                            var sonrakiKisim = metin.substring(
                              orijinalIndex + 1
                            );

                            return sonrakiKisim;
                          }
                        }
                        var last_değer =
                          metniIndexeKadarAl(
                            değerler_eleman,
                            sondanIlkBoslukIndexiniBul(değerler_eleman)
                          ) +
                          " " +
                          sondanIlkBosluktanSonrakiKisim(değerler_eleman);
                        if (x.text.includes("Çalışma Durumu")) {
                          console.log(last_değer, typeof last_değer);
                          //
                          if (String(last_değer) === "1.00 ") {
                            console.log(last_değer, "qwer");
                            last_değer = "ON";
                          } else {
                            last_değer = "OFF";
                          }
                        } else if (
                          x.text.includes("Arıza Durumu") ||
                          x.text.includes("Alarm")
                        ) {
                          if (String(last_değer) === "1.00 ") {
                            last_değer = "ALARM";
                          } else {
                            last_değer = "NORMAL";
                          }
                        }

                        return değerler.length > 0 ? (
                          değerler.map((değer) => (
                            <div
                              onContextMenu={(e) => {
                                e.preventDefault();
                                const { clientX, clientY } = e;
                                console.log(clientX, clientY);
                                var tagName = props.tag_list
                                  .filter((b) => b.tagId === x.tagId)
                                  .map((c) => c.tagName)[0];

                                document.querySelector(
                                  ".show_tagName"
                                ).innerHTML = tagName;

                                document
                                  .querySelector(".show_external_trend")
                                  .classList.toggle(
                                    "show_external_trend_active"
                                  );
                                document.querySelector(
                                  ".show_tagId"
                                ).innerHTML = x.tagId;
                                var popup = document.querySelector(
                                  ".show_external_trend"
                                );
                                const popupRect = popup.getBoundingClientRect();
                                const viewportWidth = window.innerWidth;
                                const viewportHeight = window.innerHeight;

                                // Calculate the new positions
                                let newX = clientX;
                                let newY = clientY;

                                // Adjust if the popup would overflow the right edge of the viewport
                                if (newX + popupRect.width > viewportWidth) {
                                  newX = viewportWidth - popupRect.width;
                                }

                                // Adjust if the popup would overflow the bottom edge of the viewport
                                if (newY + popupRect.height > viewportHeight) {
                                  newY = viewportHeight - popupRect.height;
                                }

                                // Adjust if the popup would overflow the left edge of the viewport
                                if (newX < 0) {
                                  newX = 0;
                                }

                                // Adjust if the popup would overflow the top edge of the viewport
                                if (newY < 0) {
                                  newY = 0;
                                }

                                // Set the position of the popup
                                popup.style.left = `${newX}px`;
                                popup.style.top = `${newY}px`;
                              }}
                              id={"pumps_gösterge_değerler_box"}
                              style={getBackgroundStyle(x.text, değer)}
                            >
                              {last_değer}
                            </div>
                          ))
                        ) : (
                          <div style={loadingStyle}>{"Veri Yükleniyor"}</div>
                        );
                      } else {
                        let array2__ = [
                          "64",
                          "67",
                          "70",
                          "73",
                          "76",
                          "79",
                          "82",
                          "85",
                          "88",
                          "91",
                        ];

                        if (array2__.indexOf(x.tagId) >= 0) {
                          var değerler = props.pumps_tags
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);
                          var değerler_eleman = değerler[0];
                          var değerler2 = props.pumps_tags
                            .filter(
                              (a) =>
                                String(a.tagId) === String(Number(x.tagId) + 1)
                            )
                            .map((b) => b.tagValue);
                          var değerler_eleman2 = değerler2[0];
                          var değerler3 = props.pumps_tags
                            .filter(
                              (a) =>
                                String(a.tagId) === String(Number(x.tagId) + 2)
                            )
                            .map((b) => b.tagValue);
                          var değerler_eleman3 = değerler3[0];

                          function sondanIlkBoslukIndexiniBul(metin) {
                            if(metin!==undefined){
                            // Metni ters çevir
                            var tersMetin = metin.split("").reverse().join("");

                            // İlk boşluğun index'ini bul
                            var ilkBoslukIndex = tersMetin.indexOf(" ");

                            // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                            var orijinalIndex =
                              metin.length - 1 - ilkBoslukIndex;

                            return orijinalIndex;
                            }
                          }

                          function metniIndexeKadarAl(metin, index) {
                            if(metin!==undefined){

                            // substring kullanarak
                            var metinSubstring = metin.substring(0, index);

                            // veya slice kullanarak

                            metinSubstring = String(metinSubstring);
                            metinSubstring = metinSubstring.replaceAll(
                              ",",
                              "."
                            );

                            metinSubstring = Number(metinSubstring).toFixed(2);

                            return metinSubstring;
                          }
                          }

                          function sondanIlkBosluktanSonrakiKisim(metin) {

                            if (metin !== undefined) {

                            // Metni ters çevir
                            var tersMetin = metin.split("").reverse().join("");

                            // İlk boşluğun index'ini bul
                            var ilkBoslukIndex = tersMetin.indexOf(" ");

                            // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                            var orijinalIndex =
                              metin.length - 1 - ilkBoslukIndex;

                            // İlk boşluğun index'inden sonraki kısmı al
                            var sonrakiKisim = metin.substring(
                              orijinalIndex + 1
                            );

                            return sonrakiKisim;
                          }
                          }

                          var last_değer =
                            metniIndexeKadarAl(
                              değerler_eleman,
                              sondanIlkBoslukIndexiniBul(değerler_eleman)
                            ) +
                            " " +
                            sondanIlkBosluktanSonrakiKisim(değerler_eleman);

                          const matchingTag1 = props.tag_list.find(
                            (tag) => tag.tagId === x.tagId
                          );

                          // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                          const decimalPlaces1 =
                            matchingTag1 && matchingTag1.tagDecimal !== null
                              ? Number(matchingTag1.tagDecimal)
                              : 2;

                          last_değer =
                            decimalPlaces1 !== 0
                              ? Number(last_değer).toFixed(decimalPlaces1)
                              : Number(last_değer).toFixed(2);
                          var last_değer2 =
                            metniIndexeKadarAl(
                              değerler_eleman2,
                              sondanIlkBoslukIndexiniBul(değerler_eleman2)
                            ) +
                            " " +
                            sondanIlkBosluktanSonrakiKisim(değerler_eleman2);

                          const matchingTag2 = props.tag_list.find(
                            (tag) => tag.tagId === x.tagId
                          );

                          // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                          const decimalPlaces2 =
                            matchingTag2 && matchingTag2.tagDecimal !== null
                              ? Number(matchingTag2.tagDecimal)
                              : 2;

                          last_değer2 =
                            decimalPlaces2 !== 0
                              ? Number(last_değer2).toFixed(decimalPlaces2)
                              : Number(last_değer2).toFixed(2);
                          var last_değer3 =
                            metniIndexeKadarAl(
                              değerler_eleman3,
                              sondanIlkBoslukIndexiniBul(değerler_eleman3)
                            ) +
                            " " +
                            sondanIlkBosluktanSonrakiKisim(değerler_eleman3);

                          const matchingTag3 = props.tag_list.find(
                            (tag) => tag.tagId === x.tagId
                          );

                          // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                          const decimalPlaces3 =
                            matchingTag3 && matchingTag3.tagDecimal !== null
                              ? Number(matchingTag3.tagDecimal)
                              : 2;

                          last_değer3 =
                            decimalPlaces3 !== 0
                              ? Number(last_değer3).toFixed(decimalPlaces3)
                              : Number(last_değer3).toFixed(2);

                          return değerler.length > 0 ? (
                            değerler.map((değer) => (
                              <div
                                className="pumps-l1-l2-l3-kapsayici"
                                style={{
                                  border: "none",
                                  backgroundColor: "transparent",
                                  position: "relative",
                                  bottom: "56%",
                                }}
                              >
                                <div
                                  className="pumps-l1-l2-l3"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",

                                    border: "none",
                                  }}
                                >
                                  <span style={{ marginRight: "10px" }}>
                                    L1:
                                  </span>
                                  <div
                                    onContextMenu={(e) => {
                                      var tagName = props.tag_list
                                        .filter((b) => b.tagId === x.tagId)
                                        .map((c) => c.tagName)[0];

                                      e.preventDefault();
                                      const { clientX, clientY } = e;
                                      console.log(clientX, clientY);
                                      document.querySelector(
                                        ".show_tagName"
                                      ).innerHTML = tagName;

                                      document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                          "show_external_trend_active"
                                        );
                                      document.querySelector(
                                        ".show_tagId"
                                      ).innerHTML = x.tagId;
                                      var popup = document.querySelector(
                                        ".show_external_trend"
                                      );
                                      const popupRect =
                                        popup.getBoundingClientRect();
                                      const viewportWidth = window.innerWidth;
                                      const viewportHeight = window.innerHeight;

                                      // Calculate the new positions
                                      let newX = clientX;
                                      let newY = clientY;

                                      // Adjust if the popup would overflow the right edge of the viewport
                                      if (
                                        newX + popupRect.width >
                                        viewportWidth
                                      ) {
                                        newX = viewportWidth - popupRect.width;
                                      }

                                      // Adjust if the popup would overflow the bottom edge of the viewport
                                      if (
                                        newY + popupRect.height >
                                        viewportHeight
                                      ) {
                                        newY =
                                          viewportHeight - popupRect.height;
                                      }

                                      // Adjust if the popup would overflow the left edge of the viewport
                                      if (newX < 0) {
                                        newX = 0;
                                      }

                                      // Adjust if the popup would overflow the top edge of the viewport
                                      if (newY < 0) {
                                        newY = 0;
                                      }

                                      // Set the position of the popup
                                      popup.style.left = `${newX}px`;
                                      popup.style.top = `${newY}px`;
                                    }}
                                    style={getBackgroundStyle(x.text, değer)}
                                  >
                                    {last_değer}
                                  </div>
                                </div>
                                <div
                                  className="pumps-l1-l2-l3"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",

                                    border: "none",
                                  }}
                                >
                                  <span style={{ marginRight: "10px" }}>
                                    L2:
                                  </span>
                                  <div
                                    onContextMenu={(e) => {
                                      var tagName = props.tag_list
                                        .filter(
                                          (b) =>
                                            b.tagId ===
                                            String(Number(x.tagId) + 1)
                                        )
                                        .map((c) => c.tagName)[0];

                                      e.preventDefault();
                                      const { clientX, clientY } = e;
                                      console.log(clientX, clientY);
                                      document.querySelector(
                                        ".show_tagName"
                                      ).innerHTML = tagName;

                                      document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                          "show_external_trend_active"
                                        );
                                      document.querySelector(
                                        ".show_tagId"
                                      ).innerHTML = Number(x.tagId) + 1;
                                      var popup = document.querySelector(
                                        ".show_external_trend"
                                      );
                                      const popupRect =
                                        popup.getBoundingClientRect();
                                      const viewportWidth = window.innerWidth;
                                      const viewportHeight = window.innerHeight;

                                      // Calculate the new positions
                                      let newX = clientX;
                                      let newY = clientY;

                                      // Adjust if the popup would overflow the right edge of the viewport
                                      if (
                                        newX + popupRect.width >
                                        viewportWidth
                                      ) {
                                        newX = viewportWidth - popupRect.width;
                                      }

                                      // Adjust if the popup would overflow the bottom edge of the viewport
                                      if (
                                        newY + popupRect.height >
                                        viewportHeight
                                      ) {
                                        newY =
                                          viewportHeight - popupRect.height;
                                      }

                                      // Adjust if the popup would overflow the left edge of the viewport
                                      if (newX < 0) {
                                        newX = 0;
                                      }

                                      // Adjust if the popup would overflow the top edge of the viewport
                                      if (newY < 0) {
                                        newY = 0;
                                      }

                                      // Set the position of the popup
                                      popup.style.left = `${newX}px`;
                                      popup.style.top = `${newY}px`;
                                    }}
                                    style={getBackgroundStyle(x.text, değer)}
                                  >
                                    {last_değer2}
                                  </div>
                                </div>
                                <div
                                  className="pumps-l1-l2-l3"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",

                                    border: "none",
                                    backgroundColor: "none",
                                  }}
                                >
                                  <span style={{ marginRight: "10px" }}>
                                    L3:
                                  </span>
                                  <div
                                    onContextMenu={(e) => {
                                      e.preventDefault();
                                      const { clientX, clientY } = e;
                                      console.log(clientX, clientY);
                                      var tagName = props.tag_list
                                        .filter(
                                          (b) =>
                                            b.tagId ===
                                            String(Number(x.tagId) + 2)
                                        )
                                        .map((c) => c.tagName)[0];
                                      document.querySelector(
                                        ".show_tagName"
                                      ).innerHTML = tagName;

                                      document
                                        .querySelector(".show_external_trend")
                                        .classList.toggle(
                                          "show_external_trend_active"
                                        );
                                      document.querySelector(
                                        ".show_tagId"
                                      ).innerHTML = Number(x.tagId) + 2;
                                      var popup = document.querySelector(
                                        ".show_external_trend"
                                      );
                                      const popupRect =
                                        popup.getBoundingClientRect();
                                      const viewportWidth = window.innerWidth;
                                      const viewportHeight = window.innerHeight;

                                      // Calculate the new positions
                                      let newX = clientX;
                                      let newY = clientY;

                                      // Adjust if the popup would overflow the right edge of the viewport
                                      if (
                                        newX + popupRect.width >
                                        viewportWidth
                                      ) {
                                        newX = viewportWidth - popupRect.width;
                                      }

                                      // Adjust if the popup would overflow the bottom edge of the viewport
                                      if (
                                        newY + popupRect.height >
                                        viewportHeight
                                      ) {
                                        newY =
                                          viewportHeight - popupRect.height;
                                      }

                                      // Adjust if the popup would overflow the left edge of the viewport
                                      if (newX < 0) {
                                        newX = 0;
                                      }

                                      // Adjust if the popup would overflow the top edge of the viewport
                                      if (newY < 0) {
                                        newY = 0;
                                      }

                                      // Set the position of the popup
                                      popup.style.left = `${newX}px`;
                                      popup.style.top = `${newY}px`;
                                    }}
                                    style={getBackgroundStyle(x.text, değer)}
                                  >
                                    {last_değer3}
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div style={loadingStyle}>{"Veri Yükleniyor"}</div>
                          );
                        }
                      }
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    pages_: state.project_reducer.pages,
    tag_ids: state.project_reducer.tag_ids,
    tag_values: state.project_reducer.tag_values,
    user_id: state.auth_reducer.user_id,
    company_id: state.project_reducer.company_id,
    tag_list: state.project_reducer.tag_list,
    white_space_: state.project_reducer.white_space_items,
    fetch_tag_value_control: state.project_reducer.fetch_tag_value_control,
    pumps_tags: state.project_reducer.pumps_tags,
  };
};
export default connect(MapStateToProps)(Pumps);
